<mat-progress-spinner [color]="color" [diameter]="diameter" mode="indeterminate"></mat-progress-spinner>
